module.exports = __webpack_public_path__ + "static/media/b1.a8257a54.PNG";